import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, TextField, Button, Card, CardContent, Drawer, List, ListItem, ListItemIcon, ListItemText, ListItemButton, Typography, Modal, Box, IconButton, CircularProgress, AppBar, Toolbar, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Checkbox } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { Close as CloseIcon, Menu as MenuIcon } from '@mui/icons-material';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { Link } from "react-router-dom";

import { getEventsByDate, convertToAmPm } from '../controller.tsx'
import { useUser } from '../Context/UserContext';

import SignInModal from '../Components/SignInModal.js';
import DonateModal from '../Components/DonateModal.js';
import NewsletterModal from '../Components/NewsletterModal.js';
import CreateEventModal from '../Components/CreateEventModal.js';
import AdComponent from '../Components/AddComponent.js';
import CompanySearch from '../Components/CompanySearch';

// todo: company search
export default function SkeletonPage() {
  const { userID, setUserID } = useUser();
  dayjs.extend(utc);

  const [compSearch, setCompSearch] = useState('');
  const [isDonate, setIsDonate] = useState(false);
  const [isNewsletter, setIsNewsletter] = useState(false);  // make description of benefits of making an account
  const [isSortBy, setIsSortBy] = useState(false);  // alphabetical, category, location, distance
  const [sortBy, setSortBy] = useState('default');
  const [isCreateEvent, setIsCreateEvent] = useState(false);
  const [isToggleDrawer, setIsToggleDrawer] = useState(false);
  const [isSignIn, setIsSignIn] = useState(false);

  const today = useMemo(() => dayjs(), []);
  const [date, setDate] = useState(today);
  const [aDate, setADate] = useState(today.format('YYYY-MM-DD'));
  const [dateEvents, setDateEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filteredEvents, setFilteredEvents] = useState([])
  const [isCompOnlyChecked, setIsCompOnlyChecked] = useState(false);

  const loadDateEvents = useCallback(async () => {
    setLoading(true);
    const events = await getEventsByDate(aDate);
    setDateEvents(events);
    setLoading(false);
  }, [aDate]);

  useEffect(() => {
    loadDateEvents();
  }, [loadDateEvents]);

  useEffect(() => {
    setFilteredEvents(dateEvents.filter(event => event.name.toLowerCase().includes(compSearch.toLowerCase())));
  }, [dateEvents, compSearch])

  const handleDateChange = (newDate) => {
    if (newDate) {
      setDate(newDate);
      setADate(newDate.format('YYYY-MM-DD'));
    }
  };

  const handleIsOnlyCompany = (e) => {
    const checked = e.target.checked
    setIsCompOnlyChecked(checked);

    if (checked) {
      setFilteredEvents(filteredEvents.filter(event => event.cID?.length > 0));
    } else {
      setFilteredEvents(dateEvents.filter(event => event.name.toLowerCase().includes(compSearch.toLowerCase())));
    }
  }

  const handleSortBy = () => {
    if (sortBy === 'default') {
      filteredEvents.sort((a, b) => a.id - b.id);
    } else if (sortBy === 'alpha') {
      filteredEvents.sort((a, b) => a.name.localeCompare(b.name));
    }
    else if (sortBy === 'distance') {
      // todo calculate distance given address of location and location of user
    }
    else if (sortBy === 'location') {
      filteredEvents.sort((a, b) => a.location.localeCompare(b.location));
    }
    setIsSortBy(false);
  }

  if (!filteredEvents) {
    return (<Typography>....</Typography>)
  }
//  return (
//    <LocalizationProvider dateAdapter={AdapterDayjs}>
//      <AppBar position="static">
//        <Toolbar onClick={() => setIsToggleDrawer(true)}>
//          <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}><MenuIcon /></IconButton>
//          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>Around Everything</Typography>
//        </Toolbar>
//      </AppBar>
//
//      <Container maxWidth="md" sx={{ overflowY: 'auto', height: '100vh' }}>
//        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//          <TextField label="Search Events" variant="outlined" fullWidth
//            value={compSearch}
//            onChange={(e) => setCompSearch(e.target.value)}
//            sx={{
//              mr: 2,
//              '@media (max-width: 600px)': {
//                fontSize: '1rem', // Adjust font size for mobile
//                padding: '8px', // Reduce padding on smaller screens
//              },
//            }}
//          />
//          <DatePicker value={date} onChange={handleDateChange} sx={{
//            '@media (max-width: 600px)': {
//              fontSize: '1rem',
//              padding: '8px',
//            },
//          }} />
//        </Box>
//
//        <FormControl>
//          <FormControlLabel
//            control={<Checkbox checked={isCompOnlyChecked} onChange={handleIsOnlyCompany} />}
//            label={"Show registered company events"}
//            labelPlacement="end"
//          />
//        </FormControl>
//
//        {userID && (
//          <Button variant="contained" color="primary" fullWidth onClick={() => setIsCreateEvent(true)} sx={{
//            mt: 2,
//            '@media (max-width: 600px)': {
//              fontSize: '1rem',
//              padding: '12px',
//            },
//            backgroundColor: '#263238',
//          }}>
//            Create Event
//          </Button>
//        )}
//
//
//        {loading ? (<Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>) : (
//          filteredEvents.map((event, index) => (
//            <React.Fragment key={index}>
//              <Link key={event.id} style={{ textDecoration: 'none' }}
//                to={`/SkeletonEvent/${encodeURIComponent(event.id || ' ')}/${encodeURIComponent(event.name || ' ')}/${encodeURIComponent(event.description || ' ')}/${encodeURIComponent(event.location || ' ')}/${encodeURIComponent(event.address || ' ')}/${encodeURIComponent(event.logo || ' ')}/${encodeURIComponent(event.date || ' ')}/${encodeURIComponent(event.time_string || ' ')}/${encodeURIComponent(event.duration || ' ')}/${encodeURIComponent(event.link || ' ')}`}
//              >
//                <Card sx={{
//                  mb: 2, p: 2,
//                  '@media (max-width: 600px)': {
//                    padding: '10px',
//                  },
//                }}>
//                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
//                    <Box sx={{ width: 80, height: 80, overflow: 'hidden', borderRadius: '8px', display: 'flex', justifyContent: 'center', flexShrink: 0, }}>
//                      <img src={event.logo} alt="Event" style={{ width: '100%', height: '100%', objectFit: 'cover', }} />
//                    </Box>
//
//                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, }}>
//                      <Typography variant="h6" fontWeight="bold" sx={{
//                        fontSize: '1.2rem',
//                        '@media (max-width: 600px)': {
//                          fontSize: '1rem',
//                        },
//                      }}>
//                        {event.name}
//                      </Typography>
//
//                      <Typography variant="body2" color="textSecondary" sx={{
//                        fontSize: '0.9rem',
//                        '@media (max-width: 600px)': {
//                          fontSize: '0.8rem',
//                        },
//                      }}>
//                        {event.location}
//                      </Typography>
//
//                      <Typography variant="body2" color="textSecondary" sx={{
//                        fontSize: '0.9rem',
//                        '@media (max-width: 600px)': {
//                          fontSize: '0.8rem',
//                        },
//                      }}>
//                        {convertToAmPm(event.time_string)}
//                      </Typography>
//                    </Box>
//                  </CardContent>
//                </Card>
//              </Link>
//
//              {(index + 1) % 3 === 0 && (
//                <Box my={3}>
//                  <AdComponent
//                    adSlot="1708839895"
//                    adFormat="fluid"
//                    layoutKey="-h4+5-w-1c+60"
//                  />
//                </Box>
//              )}
//            </React.Fragment>
//          ))
//        )}
//        <Drawer open={isToggleDrawer} onClose={() => setIsToggleDrawer(false)}>
//          <List>
//            <ListItem disablePadding>
//              <ListItemButton onClick={() => {
//                setIsDonate(true);
//                setIsToggleDrawer(false)
//              }}>
//                <ListItemIcon><InboxIcon /></ListItemIcon>
//                <ListItemText primary="Support the App" />
//              </ListItemButton>
//            </ListItem>
//
//            <ListItem disablePadding>
//              <ListItemButton onClick={() => {
//                setIsNewsletter(true);
//                setIsToggleDrawer(false);
//              }}>
//                <ListItemIcon><InboxIcon /></ListItemIcon>
//                <ListItemText primary="Register to post events" />
//              </ListItemButton>
//            </ListItem>
//
//            <ListItem disablePadding>
//              <ListItemButton onClick={() => {
//                setIsSortBy(true)
//                setIsToggleDrawer(false);
//              }}>
//                <ListItemIcon><InboxIcon /></ListItemIcon>
//                <ListItemText primary="Sort By" />
//              </ListItemButton>
//            </ListItem>
//
//            {!userID && (
//              <ListItem disablePadding>
//                <ListItemButton onClick={() => {
//                  setIsSignIn(true)
//                  setIsToggleDrawer(false);
//                }}>
//                  <ListItemIcon><InboxIcon /></ListItemIcon>
//                  <ListItemText primary="Sign in" />
//                </ListItemButton>
//              </ListItem>
//            )}
//            {userID && (
//              <ListItem disablePadding>
//                <ListItemButton onClick={() => {
//                  setUserID(null);
//                  setIsToggleDrawer(false);
//                }}>
//                  <ListItemIcon><InboxIcon /></ListItemIcon>
//                  <ListItemText primary="Logout" />
//                </ListItemButton>
//              </ListItem>
//            )}
//          </List>
//        </Drawer>
//
//        <SignInModal isOpen={isSignIn} setIsOpen={setIsSignIn} />
//        <DonateModal isOpen={isDonate} setIsOpen={setIsDonate} />
//        <NewsletterModal isOpen={isNewsletter} setIsOpen={setIsNewsletter} />
//        <CreateEventModal isOpen={isCreateEvent} setIsOpen={setIsCreateEvent} />
//
//        <Modal open={isSortBy} onClose={() => setIsSortBy(false)}>
//          <Box sx={{
//            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//            bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
//            maxWidth: '90%', '@media (max-width: 600px)': {
//              width: '90%',
//              padding: 2,
//            }
//          }}>
//            <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={() => setIsSortBy(false)}><CloseIcon /></IconButton>
//            <FormControl>
//              <FormLabel id="sort-by-form-label">SORT BY</FormLabel>
//              <RadioGroup name="sort-by-radio-buttons-group"
//                value={sortBy}
//                onChange={(e) => { setSortBy(e.target.value) }}
//              >
//                <FormControlLabel value="default" control={<Radio />} label="Default" />
//                <FormControlLabel value="alpha" control={<Radio />} label="Alphabetical" />
//                <FormControlLabel value="location" control={<Radio />} label="Location" />
//              </RadioGroup>
//            </FormControl>
//            <Button variant="contained" sx={{ mb: 1, backgroundColor: '#263238' }} onClick={handleSortBy}>Sort</Button>
//          </Box>
//        </Modal>
//      </Container>
//    </LocalizationProvider>
//  );


return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AppBar position="static">
        <Toolbar onClick={() => setIsToggleDrawer(true)}>
          <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}><MenuIcon /></IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>Around Everything</Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ overflowY: 'auto', height: '100vh' }}>
        {/* Top controls: Search Events, CompanySearch (styled like Search Events), DatePicker */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexDirection={{ xs: 'column', sm: 'row' }} gap={1}>
          <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
            <TextField label="Search Events" variant="outlined" fullWidth
              value={compSearch}
              onChange={(e) => setCompSearch(e.target.value)}
              sx={{
                mr: 2,
                '@media (max-width: 600px)': {
                  fontSize: '1rem', // Adjust font size for mobile
                  padding: '8px', // Reduce padding on smaller screens
                },
              }}
            />
          </Box>

          {/* CompanySearch placed and styled similarly to the Search Events box */}
          <Box sx={{ width: { xs: '100%', sm: '36%' } }}>
            {/* CompanySearch internally renders a small TextField; its container uses same responsive width rules */}
            <CompanySearch
              placeholder="Search companies..."
            />
          </Box>

          <DatePicker value={date} onChange={handleDateChange} sx={{
            '@media (max-width: 600px)': {
              fontSize: '1rem',
              padding: '8px',
            },
          }} />
        </Box>

        <FormControl>
          <FormControlLabel
            control={<Checkbox checked={isCompOnlyChecked} onChange={handleIsOnlyCompany} />}
            label={"Show registered company events"}
            labelPlacement="end"
          />
        </FormControl>

        {userID && (
          <Button variant="contained" color="primary" fullWidth onClick={() => setIsCreateEvent(true)} sx={{
            mt: 2,
            '@media (max-width: 600px)': {
              fontSize: '1rem',
              padding: '12px',
            },
            backgroundColor: '#263238',
          }}>
            Create Event
          </Button>
        )}


        {loading ? (<Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>) : (
          filteredEvents.map((event, index) => (
            <React.Fragment key={index}>
              <Link key={event.id} style={{ textDecoration: 'none' }}
                to={`/SkeletonEvent/${encodeURIComponent(event.id || ' ')}/${encodeURIComponent(event.name || ' ')}/${encodeURIComponent(event.description || ' ')}/${encodeURIComponent(event.location || ' ')}/${encodeURIComponent(event.address || ' ')}/${encodeURIComponent(event.logo || ' ')}/${encodeURIComponent(event.date || ' ')}/${encodeURIComponent(event.time_string || ' ')}/${encodeURIComponent(event.duration || ' ')}/${encodeURIComponent(event.link || ' ')}`}
              >
                <Card sx={{
                  mb: 2, p: 2,
                  '@media (max-width: 600px)': {
                    padding: '10px',
                  },
                }}>
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
                    <Box sx={{ width: 80, height: 80, overflow: 'hidden', borderRadius: '8px', display: 'flex', justifyContent: 'center', flexShrink: 0, }}>
                      <img src={event.logo} alt="Event" style={{ width: '100%', height: '100%', objectFit: 'cover', }} />
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, }}>
                      <Typography variant="h6" fontWeight="bold" sx={{
                        fontSize: '1.2rem',
                        '@media (max-width: 600px)': {
                          fontSize: '1rem',
                        },
                      }}>
                        {event.name}
                      </Typography>

                      <Typography variant="body2" color="textSecondary" sx={{
                        fontSize: '0.9rem',
                        '@media (max-width: 600px)': {
                          fontSize: '0.8rem',
                        },
                      }}>
                        {event.location}
                      </Typography>

                      <Typography variant="body2" color="textSecondary" sx={{
                        fontSize: '0.9rem',
                        '@media (max-width: 600px)': {
                          fontSize: '0.8rem',
                        },
                      }}>
                        {convertToAmPm(event.time_string)}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Link>

              {(index + 1) % 3 === 0 && (
                <Box my={3}>
                  <AdComponent
                    adSlot="1708839895"
                    adFormat="fluid"
                    layoutKey="-h4+5-w-1c+60"
                  />
                </Box>
              )}
            </React.Fragment>
          ))
        )}
        <Drawer open={isToggleDrawer} onClose={() => setIsToggleDrawer(false)}>
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => {
                setIsDonate(true);
                setIsToggleDrawer(false)
              }}>
                <ListItemIcon><InboxIcon /></ListItemIcon>
                <ListItemText primary="Support the App" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton onClick={() => {
                setIsNewsletter(true);
                setIsToggleDrawer(false);
              }}>
                <ListItemIcon><InboxIcon /></ListItemIcon>
                <ListItemText primary="Register to post events" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton onClick={() => {
                setIsSortBy(true)
                setIsToggleDrawer(false);
              }}>
                <ListItemIcon><InboxIcon /></ListItemIcon>
                <ListItemText primary="Sort By" />
              </ListItemButton>
            </ListItem>

            {!userID && (
              <ListItem disablePadding>
                <ListItemButton onClick={() => {
                  setIsSignIn(true)
                  setIsToggleDrawer(false);
                }}>
                  <ListItemIcon><InboxIcon /></ListItemIcon>
                  <ListItemText primary="Sign in" />
                </ListItemButton>
              </ListItem>
            )}
            {userID && (
              <ListItem disablePadding>
                <ListItemButton onClick={() => {
                  setUserID(null);
                  setIsToggleDrawer(false);
                }}>
                  <ListItemIcon><InboxIcon /></ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Drawer>

        <SignInModal isOpen={isSignIn} setIsOpen={setIsSignIn} />
        <DonateModal isOpen={isDonate} setIsOpen={setIsDonate} />
        <NewsletterModal isOpen={isNewsletter} setIsOpen={setIsNewsletter} />
        <CreateEventModal isOpen={isCreateEvent} setIsOpen={setIsCreateEvent} />

        <Modal open={isSortBy} onClose={() => setIsSortBy(false)}>
          <Box sx={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
            maxWidth: '90%', '@media (max-width: 600px)': {
              width: '90%',
              padding: 2,
            }
          }}>
            <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={() => setIsSortBy(false)}><CloseIcon /></IconButton>
            <FormControl>
              <FormLabel id="sort-by-form-label">SORT BY</FormLabel>
              <RadioGroup name="sort-by-radio-buttons-group"
                value={sortBy}
                onChange={(e) => { setSortBy(e.target.value) }}
              >
                <FormControlLabel value="default" control={<Radio />} label="Default" />
                <FormControlLabel value="alpha" control={<Radio />} label="Alphabetical" />
                <FormControlLabel value="location" control={<Radio />} label="Location" />
              </RadioGroup>
            </FormControl>
            <Button variant="contained" sx={{ mb: 1, backgroundColor: '#263238' }} onClick={handleSortBy}>Sort</Button>
          </Box>
        </Modal>
      </Container>
    </LocalizationProvider>
  );
}
